import { store } from '@/store/store';
import $http from '@/http';
import Util from '@/util';
import eventBus from '@/EventBus';
import helpers from '@/util/helpers';
import callChannelType from '@/constants/callChannelType';

var retryCount = {
  call: 0, // klcns 콜 웹소켓
  status: 0, // 콜 통계 웹소켓 (whiteeye)
  api: 0
};

async function initKlcns() {
  const parseLoginToken = Util.parseLoginToken();
  if (!parseLoginToken) return;

  const callServerType = parseLoginToken.callServerType;
  if (!callServerType) return;

  try {
    // 콜 모드 세팅
    if (callServerType && callServerType.indexOf('KLCNS') > -1) {
      store.commit('setCallMode', callChannelType.KLCNS);
    }

    // 콜 서버 타입 세팅
    store.commit('setCallServerType', callServerType);

    // 통계 서버 (whiteeye) 연결 도메인 세팅
    store.commit('setCallStatus');

    // 상담사 상태 관리용 상담사 상태목록 세팅
    store.dispatch('getCallWorkingStatusList');

    // 콜 API url 세팅
    store.commit('setCallApiUrl', helpers.findCallApiUrl(callServerType));

    // 콜 브랜드 세팅
    const { allBrandList, brandList } = await getBrandList();
    store.commit('setCallAllBrandList', allBrandList);
    store.commit('setCallBrandList', brandList);

    // 콜 상담사 정보 세팅
    // 1. 상담사 정보 존재 여부 값
    // 2. 내선번호
    // 3.상담사 계정 사용 가능 여부
    await setKlcnsAgentInfo();

    // 소켓 최초 연결일 때에는 kill=true로 넘긴다.
    // 재연결일 경우에는 kill 옵션을 false로 넘겨 기존 연결 세션을 유지하도록 한다.
    const killOption = store.getters.isFirstConnect;

    // 콜 웹소켓 url 세팅
    let url = `${helpers.findCallWebsocketUrl(callServerType)}:8060`;
    if (url.indexOf('agent_id') < 0) {
      // klcns의 경우, 중복탭 방지를 위해 kill 옵션을 넘겨준다.
      store.commit('setCallWebSocketUrl', `${url}/ws/?agent_id=${store.getters.telNumber}&kill=${killOption}`);
    }

    eventBus.$emit('set-call-agent');

    // 상담데스크 UI 컨트롤
    store.commit('changeIsInitUi', true);
    store.commit('initDimmed');
  } catch (e) {
    console.error(e);
  }
}

async function getBrandList() {
  // kt 전용으로 나온 api이지만 klcns와 공유해서 사용한다.
  const { data } = await $http({
    url: '/api/v1/call/service/kt-cloud/call-service-info',
    method: 'GET'
  });
  try {
    const allBrandList = data.map((brand) => {
      return { ...brand, calledNumber: brand.serviceNumber, representativeNumber: brand.serviceNumber, name: brand.serviceName };
    });
    const brandList = allBrandList.filter((brand) => !!brand.belongTo);
    return { allBrandList: allBrandList, brandList: brandList };
  } catch (e) {
    console.error(e);
    return { allBrandList: [], brandList: [] };
  }
}

async function setKlcnsAgentInfo() {
  const { agentId, loginId } = Util.parseLoginToken();
  store.commit('setCallLoginId', loginId);

  const response = await $http({
    url: `/api/agent/${agentId}/call/info`,
    method: 'GET'
  });

  try {
    const data = response.data.data;
    if (Object.keys(data).length > 0 && data.extensionNumber) {
      store.commit('changeIsExistCallAgent', true);
      store.commit('changeTelNumber', data.extensionNumber);
      store.commit('changeEnabledCallAgent', data.approvalStatus === 'ENABLE');
    } else {
      store.commit('changeIsExistCallAgent', false);
      store.commit('changeEnabledCallAgent', false);
    }
  } catch (e) {
    console.error(e);
    store.commit('changeIsExistCallAgent', false);
    store.commit('changeEnabledCallAgent', false);
    store.commit('initDimmed');
  }
}

function connectCallSocket() {
  setTimeout(() => {
    if (retryCount.call < 5) {
      store.dispatch('klcns_connect');
      retryCount.call += 1;
    } else {
      console.log('call websocket connection failed');
    }
  }, 500);
}

function connectStatusSocket() {
  setTimeout(() => {
    if (retryCount.status < 5) {
      store.dispatch('call_status_connect');
      retryCount.status += 1;
    } else {
      console.log('call status websocket connection failed');
    }
  }, 500);
}

function connectApiSocket() {
  const { IS_CALL_API_CONNECTED, callApiUserId, loginId } = store.getters;
  if (IS_CALL_API_CONNECTED && callApiUserId === loginId) return;
  setTimeout(() => {
    if (retryCount.api < 5) {
      store.dispatch('call_api_connect');
      retryCount.api += 1;
    } else {
      console.log('call api websocket connection failed');
    }
  }, 500);
}

function resetCount(type) {
  // type: call, status, api
  retryCount[type] = 0;
}

function setCount(type, count) {
  // type: call, status, api
  retryCount[type] = count;
}

export default {
  initKlcns,
  connectCallSocket,
  connectStatusSocket,
  connectApiSocket,
  resetCount,
  setCount
};



// WEBPACK FOOTER //
// ./src/util/call/klcns/initKlcns.js